'use client';

import React from 'react';
import { useEffect, useState } from 'react';

const ClientOnly = ({ children }: { children: React.ReactNode }) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => setIsClient(true), []);

  return isClient ? <>{children}</> : null;
};

export default ClientOnly;
